/**
 * The images a message's content carries, as sources an <img> can draw: a tool's screenshot is kept in the
 * transcript as base64, so the chat shows it from there, live and after a reload.
 *
 * Kept JSX-free so `node --test` can load it directly, like `notices.ts`.
 */

/** Raster formats only: an SVG is a document that can carry script and links, not a picture to inline. */
const RASTER = new Set(["image/png", "image/jpeg", "image/gif", "image/webp"]);
const BASE64 = /^[A-Za-z0-9+/]+={0,2}$/;

/** A data: URL for each raster image block in `content`, in order; anything else is left out. */
export function imageSources(content: unknown): string[] {
	if (!Array.isArray(content)) return [];
	const out: string[] = [];
	for (const block of content as Array<{ type?: unknown; mimeType?: unknown; data?: unknown } | null>) {
		if (block?.type !== "image" || typeof block.data !== "string" || typeof block.mimeType !== "string") continue;
		const mime = block.mimeType.toLowerCase();
		if (RASTER.has(mime) && BASE64.test(block.data)) out.push(`data:${mime};base64,${block.data}`);
	}
	return out;
}
